import React, { useEffect, useState } from "react";
import { Table, Popconfirm, Space } from "antd";
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Modal,
  TextField,
  Avatar,
  Typography,
  Box,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DeleteOutlined, EditOutlined, FileAddTwoTone } from "@ant-design/icons";
import { ScheduleMessageApiService } from "../../services/api/ScheduleMessageAPIService";
import {
  API_ERROR_MESSAGE,
  API_SUCCESS_MESSAGE,
  BUTTON,
  TABLE_HEADING,
} from "../../shared/constants";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function FestiveUpdatesMessages() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTime, setSelectedTime] = useState(dayjs());
  const [snackData, setSnackData] = useState({ show: false, message: "", type: "error" });
  const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 100,
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
      const [openModal, setOpenModal] = useState(false);

    const [form, setForm] = useState({ date: "",occasion:"", schedule_time: "", message: "" });
    const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    fetchMessageDetails();
  }, []);

  const fetchMessageDetails = () => {
    setLoading(true);
    ScheduleMessageApiService.messageListing("festive_updates")
      .then((response) => {
        setSnackData({
          show: true,
          message: response.message || API_SUCCESS_MESSAGE.LISTING_FETCH,
          type: "success",
        });

        setData(response);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

   const handleAddNew = () => {
      setIsEdit(false);
      setForm({ date: "",occasion:"", schedule_time: "", message: "" });
      setIsModalOpen(true);
    };

    const handleEdit = (record) => {
      setIsEdit(true);
      setForm({ ...record });
      setIsModalOpen(true);
    };

    const handleDelete = (record) => {
      console.log("record",record)
      ScheduleMessageApiService.messageDelete("festive_updates", record.id,record.date)
        .then(() => {
          setSnackData({
            show: true,
            message: "Deleted successfully!",
            type: "success",
          });
          fetchMessageDetails();
        })
        .catch(() =>
          setSnackData({
            show: true,
            message: "Failed to delete",
            type: "error",
          })
        );
    };

    const handleSave = () => {
        let payload ={}

        if(isEdit)
        {
          payload =
          {
            occasion: form.occasion,
            schedule_time: form.schedule_time,
            message: form.message
          }

        }
        else{
          payload =
          {
            id:uuidv4().replace(/-/g, ''),
            date: form.date,
            occasion: form.occasion,
            schedule_time: form?.schedule_time || selectedTime,
            message: form.message
          }
        }

        const apiCall = isEdit
          ? ScheduleMessageApiService.messageEdit("festive_updates", payload,form.id,form.date, "")
          : ScheduleMessageApiService.messageCreation("festive_updates", payload,"");

        apiCall
          .then(() => {
            setSnackData({
              show: true,
              message: isEdit ? "Updated successfully!" : "Created successfully!",
              type: "success",
            });
            fetchMessageDetails();
            setIsModalOpen(false);
          })
          .catch(() =>
            setSnackData({
              show: true,
              message: "API Error!",
              type: "error",
            })
          );
      };

  const columns = [
    {
      title: TABLE_HEADING.DATE,
      dataIndex: 'date',
      width:"10%",
    },
    {
      title: TABLE_HEADING.OCCASION,
      dataIndex: 'occasion',
      width:"20%",
    },
    {
        title: TABLE_HEADING.SCHEDULE_TIME,
        dataIndex: 'schedule_time',
        width:"20%",
        render: (schedule_time) => {
          if (!schedule_time) return '';

          const easternTime = dayjs.utc(`${dayjs().format('YYYY-MM-DD')}T${schedule_time}`)
                             .tz('America/New_York')
                             .format('hh:mm A z'); // z = EST/EDT

          return easternTime;
        },
      },
    {
      title: TABLE_HEADING.MESSAGE,
      dataIndex: 'message',
    },
    {
      title: TABLE_HEADING.ACTION,
      key: "action",
      render: (record) => (
        <Space>
                 <Button onClick={() => handleEdit(record)} startIcon={<EditOutlined />}>
                   {BUTTON.EDIT}
                 </Button>
                 <Popconfirm
                   title="Are you sure to delete this message?"
                   onConfirm={() => handleDelete(record)}
                   okText="Yes"
                   cancelText="No"
                 >
                   <Button startIcon={<DeleteOutlined style={{color:"red"}}/>}> </Button>
                 </Popconfirm>
               </Space>
      ),
    },
  ];

  return (
    <>
     <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
             <Box display="flex" alignItems="center" gap={2}>
               <Avatar sx={{ bgcolor: "blue", width: 48, height: 48, fontSize: 20 }}>F</Avatar>
               <Typography variant="h6" fontWeight="bold">
                 Festive <Typography component="span">– Messages</Typography>
               </Typography>
             </Box>
             <Button
               variant="contained"
               color="primary"
               startIcon={<FileAddTwoTone />}
               onClick={handleAddNew}
             >
               Add New
             </Button>
           </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : (
        <Table
        className="custom-table"
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '200'],
          onChange: (page, pageSize) => {
            setPagination({ current: page, pageSize });
            window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top on page change
          },
        }}
      />
      )}

      <Dialog
                    open={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    maxWidth="md"
                    fullWidth
                  >
           <DialogTitle>{isEdit? "Update": "Add new" }</DialogTitle>
           <DialogContent>
              <Box display="flex" flexDirection="column" gap={2} p={2}>
                <TextField
                  label="Date"
                  value={form.date}
                  onChange={(e) => setForm({ ...form, date: e.target.value })}

                  fullWidth
                />
                 <TextField
                  label="Occasion"
                  value={form.occasion}
                  onChange={(e) => setForm({ ...form, occasion: e.target.value })}

                  fullWidth
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    label="Schedule Time (UTC)"
                    value={
                            form.schedule_time
                              ? dayjs
                                  .utc(`${dayjs().format("YYYY-MM-DD")}T${form.schedule_time}`)
                              : null
                          }
                    onChange={(newValue) => {
                      if (newValue) {
                        const timeOnly = newValue.format("HH:mm:ss"); // e.g., "14:30:00"
                        setSelectedTime(newValue);
                        setForm({ ...form, schedule_time: timeOnly });
                      }
                    }}
                    renderInput={(params) => <TextField
                                            {...params}
                                            fullWidth
                                            helperText="Time is stored and shown in UTC"
                                          />}
                  />
                </LocalizationProvider>
                <TextField
                  label="Message"
                  value={form.message}
                  multiline
                  minRows={4}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  fullWidth
                />
                </Box>
                </DialogContent>
                <DialogActions>
                <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                  <Button variant="outlined" onClick={() => setIsModalOpen(false)}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleSave}>
                    {isEdit ? "Update" : "Create"}
                  </Button>
                </Box>
                </DialogActions>

                  </Dialog>

      <Snackbar
        style={{ top: "80px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
    </>
  );
}
